/** @jsxRuntime classic */
/** @jsx jsx */
import PropTypes from "prop-types";
import Sector from "./Sector";
import { jsx } from '@emotion/core';
const Sectors = ({
  center,
  data,
  onSectorHover,
  expandSize,
  strokeWidth,
  strokeColor,
  startAngle,
  angleMargin,
  ...props
}) => {
  const total = data.reduce((prev, current) => current.quantity + prev, 0);
  let angleStart = startAngle;
  let angleEnd = startAngle;
  return total > 0 ? jsx("g", null, data.map((d, i) => {
    const isLarge = d.quantity / total > 0.5;
    const angle = 360 * d.quantity / total;
    const radius = center + (d.expanded === 'true' ? expandSize : 0) - strokeWidth / 2;
    angleStart = angleEnd;
    angleMargin = angleMargin > angle ? angle : angleMargin;
    angleEnd = angleStart + angle - angleMargin;
    const x1 = center + radius * Math.cos(Math.PI * angleStart / 180);
    const y1 = center + radius * Math.sin(Math.PI * angleStart / 180);
    const x2 = center + radius * Math.cos(Math.PI * angleEnd / 180);
    const y2 = center + radius * Math.sin(Math.PI * angleEnd / 180);
    const path = `
                    M${center},${center}
                    L${x1},${y1}
                    A${radius},${radius}
                    0 ${isLarge ? 1 : 0},1
                    ${x2},${y2}
                    z
                `;
    angleEnd += angleMargin;
    return jsx(Sector, {
      key: "sector" + i,
      fill: d.color,
      path: path,
      href: d.href,
      strokeColor: strokeColor,
      strokeWidth: strokeWidth,
      total: total,
      onMouseEnter: e => onSectorHover(d, i, e),
      onMouseLeave: e => onSectorHover(null, null, e),
      onTouchEnd: e => onSectorHover(null, null, e),
      onTouchStart: e => onSectorHover(d, i, e),
      ...props,
      ...d
    });
  })) : null;
};
Sectors.defaultProps = {
  expandSize: 2
};
Sectors.propTypes = {
  center: PropTypes.number.isRequired,
  /** The array of elements that appear in the PieChart */
  data: PropTypes.arrayOf(PropTypes.shape({
    color: PropTypes.string.isRequired,
    name: PropTypes.string,
    quantity: PropTypes.number.isRequired
  })).isRequired,
  /** returns the data of the object to be hover */
  onSectorHover: PropTypes.func,
  /** the Size expand On Hover */
  expandSize: PropTypes.number,
  /** the StrokeWidth change color border and Stroke */
  strokeColor: Sector.propTypes.strokeColor,
  /** The strokeWidth attribute is a presentation attribute defining the width of the stroke to be applied to the shape */
  strokeWidth: Sector.propTypes.strokeWidth,
  /** The starting angle is drawn in a circle from data first */
  startAngle: PropTypes.number,
  /** */
  angleMargin: PropTypes.number
};
export default Sectors;